module.exports = __webpack_public_path__ + "img/vip.bc05f1e5.png";